export var SET_PARTNER_ACCOUNTS = "SET_PARTNER_ACCOUNTS";
export var SET_SELECTED_PARTNER = "SET_SELECTED_PARTNER";
export var PARTNER_REVENUE_SUMMARY = "PARTNER_REVENUE_SUMMARY";
export var PARTNER_CLIENT_SUMMARY = "PARTNER_CLIENT_SUMMARY";
export var PARTNER_DROPDOWN_CLEAR = "PARTNER_DROPDOWN_CLEAR";
